import { useContext } from 'react';
import { CartContext } from '../../context/cart.context';

import CheckOutItem from '../../components/checkout-item/checkout-item.component';
import  PaymentForm  from "../../components/payment-form/payment-form-component";


import './checkout.styles.scss'

const Checkout = () => {

    const { cartItems, cartTotal } = useContext(CartContext)

    return (
        <div className='checkout-container'>
            <div className='checkout-header'>
                <div className='header-block'>
                    <span>Product</span>
                </div>
                <div className='header-block'>
                    <span>Description</span>
                </div>
                <div className='header-block'>
                    <span>Quanity</span>
                </div>
                <div className='header-block'>
                    <span>Price</span>
                </div>
                <div className='header-block'>
                    <span>Remove</span>
                </div>
            </div>
            {cartItems.map((cartItem) => 
                <CheckOutItem key={cartItem.id} cartItem={cartItem} />
            )}
            <span className='total'>Total: &#8377;{cartTotal}</span>
            <div className='payment-form'>
            <PaymentForm />
            </div>
        </div>
    )
}

export default Checkout;
